<template>
  <div
    :id="id"
    class="chart"
  />
</template>

<script>
import * as echarts from 'echarts';
const fwq = require('../../assets/img/fwq.png');
const gkj = require('../../assets/img/gkj.png');
const cjx = require('../../assets/img/cjx.png');
// const ywj = require('../../assets/img/ywj.png');
// const llj = require('../../assets/img/llj.png');
// const gl = require('../../assets/img/gl.png');
// const ylcgq = require('../../assets/img/ylcgq.png');
// const zbbsq = require('../../assets/img/zbbsq.png');
const itemBg1 = require('../../assets/img/itemBg1.png');
const itemBgRed = require('../../assets/img/itemBgRed.png');
const fwqRed = require('../../assets/img/fwqRed.png');
const gkjRed = require('../../assets/img/gkjRed.png');
const cjxRed = require('../../assets/img/cjxRed.png');
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    id: {
      type: String,
      default: 'id'
    },
    title: {
      type: String,
      default: 'id'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      chart: null,
      screenWidth: window.screen.width == 960? 'small' :window.screen.width == 1280 || Math.floor(window.screen.width * window.devicePixelRatio) == 3840 ? 'max' : 'normal'
    }
  },
  mounted() {
    // this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart(dataList) {
      this.chart = echarts.init(document.getElementById(this.id))
      delete dataList.msg
      const list = ['serverStatus', 'industrialComputerStatus', 'collectionTankStatus', 'liquidLevelGaugeStatus', 'flowStatus', 'powerTransmitterStatus', 'pressureSensorStatus', 'frequencySensorStatus']
      for (let i = 0; i < list.length; i++) {
        dataList[list[i]] = dataList[list[i]] == 1 ? true : false
      }
      let data = [{
        name: '服务器',
        label: {
          width: this.screenWidth == 'small'? 75 : 105,
          height: this.screenWidth == 'small'? 30 : 40,
          lineHeight: this.screenWidth == 'small'? 30 : 40,
          // borderWidth: 0.5,  // 边框宽度
          // borderRadius: 20,  // 边框圆角
          // borderColor: "#92b188",   // 文字块的边框色
          backgroundColor: {
            image: dataList.serverStatus? itemBgRed : itemBg1
          },
          color: '#fff',
          rich: {
            img1: {
              backgroundColor: {
                image: dataList.serverStatus? fwqRed : fwq,
              },
              height: this.screenWidth == 'small'? 10 : 14,
              align: 'center',
            },
            text: {
              padding: [2, 0, 0, 5],
              fontSize: this.screenWidth == 'small'? 10 : 12
            }
          },
          formatter: function (param) {
            var res = "";
            res += '{img1|}' + `{text|${param.name}}`;
            return res;
          },
        },
        children: [
          {
            name: '工控机',
            label: {
              width: this.screenWidth == 'small'? 75 : 105,
              height: this.screenWidth == 'small'? 30 : 40,
              lineHeight: this.screenWidth == 'small'? 30 : 40,
              // borderWidth: 0.5,  // 边框宽度
              // borderRadius: 20,  // 边框圆角
              // borderColor: "#92b188",   // 文字块的边框色
              backgroundColor: {
                image: dataList.industrialComputerStatus? itemBgRed : itemBg1
              },
              color: '#fff',
              rich: {
                img1: {
                  backgroundColor: {
                    image: dataList.industrialComputerStatus? gkjRed : gkj,
                  },
                  height: this.screenWidth == 'small'? 10 : 14,
                  align: 'center'
                },
                text: {
                  padding: [2, 0, 0, 5],
                  fontSize: this.screenWidth == 'small'? 10 : 12
                }
              },
              formatter: function (param) {
                var res = "";
                res += '{img1|}' + `{text|${param.name}}`;
                return res;
              },
            },
            children: [{
              name: '采集箱',
              label: {
                width: this.screenWidth == 'small'? 75 : 105,
                height: this.screenWidth == 'small'? 30 : 40,
                lineHeight: this.screenWidth == 'small'? 30 : 40,
                // borderWidth: 0.5,  // 边框宽度
                // borderRadius: 20,  // 边框圆角
                // borderColor: "#92b188",   // 文字块的边框色
                backgroundColor: {
                  image: dataList.collectionTankStatus? itemBgRed : itemBg1
                },
                color: '#fff',
                rich: {
                  img1: {
                    backgroundColor: {
                      image: dataList.collectionTankStatus? cjxRed : cjx,
                    },
                    height: this.screenWidth == 'small'? 10 : 14,
                    align: 'center'
                  },
                  text: {
                    padding: [2, 0, 0, 5],
                    fontSize: this.screenWidth == 'small'? 10 : 12
                  }
                },
                formatter: function (param) {
                  var res = "";
                  res += '{img1|}' + `{text|${param.name}}`;
                  return res;
                },
              },
              children: [{
                name: '液位计',
                label: {
                  width: this.screenWidth == 'small'? 50 : 65,
                  height: this.screenWidth == 'small'? 30 : 40,
                  lineHeight: this.screenWidth == 'small'? 30 : 40,
                  // borderWidth: 0.5,  // 边框宽度
                  // borderRadius: 20,  // 边框圆角
                  // borderColor: "#92b188",   // 文字块的边框色
                  backgroundColor: {
                    image: dataList.liquidLevelGaugeStatus? itemBgRed : itemBg1
                  },
                  color: '#fff',
                  rich: {
                    // img1: {
                    //   backgroundColor: {
                    //     image: ywj,
                    //   },
                    //   height: 16,
                    //   align: 'center'
                    // },
                    text: {
                      fontSize: this.screenWidth == 'small'? 8 : 10,
                      padding: [2, 0, 0, 5],
                      align: 'center'
                    }
                  },
                  formatter: function (param) {
                    var res = "";
                    res += '{img1|}' + `{text|${param.name}}`;
                    return res;
                  },
                },
              }, {
                name: '流量计',
                label: {
                  width: this.screenWidth == 'small'? 50 : 65,
                  height: this.screenWidth == 'small'? 30 : 40,
                  lineHeight: this.screenWidth == 'small'? 30 : 40,
                  // borderWidth: 0.5,  // 边框宽度
                  // borderRadius: 20,  // 边框圆角
                  // borderColor: "#92b188",   // 文字块的边框色
                  backgroundColor: {
                    image: dataList.flowStatus? itemBgRed : itemBg1
                  },
                  color: '#fff',
                  rich: {
                    // img1: {
                    //   backgroundColor: {
                    //     image: llj,
                    //   },
                    //   height: 16,
                    //   align: 'center'
                    // },
                    text: {
                      fontSize: this.screenWidth == 'small'? 8 : 10,
                      padding: [2, 0, 0, 5],
                      align: 'center'
                    }
                  },
                  formatter: function (param) {
                    var res = "";
                    res += '{img1|}' + `{text|${param.name}}`;
                    return res;
                  },
                },
              }, {
                name: '功率变送器',
                label: {
                  width: this.screenWidth == 'small'? 50 : 65,
                  height: this.screenWidth == 'small'? 30 : 40,
                  lineHeight: this.screenWidth == 'small'? 30 : 40,
                  // borderWidth: 0.5,  // 边框宽度
                  // borderRadius: 20,  // 边框圆角
                  // borderColor: "#92b188",   // 文字块的边框色
                  backgroundColor: {
                    image: dataList.powerTransmitterStatus? itemBgRed : itemBg1
                  },
                  color: '#fff',
                  rich: {
                    // img1: {
                    //   backgroundColor: {
                    //     image: gl,
                    //   },
                    //   height: 16,
                    //   align: 'center'
                    // },
                    text: {
                      fontSize: this.screenWidth == 'small'? 8 : 10,
                      padding: [2, 0, 0, 5],
                      align: 'center'
                    }
                  },
                  formatter: function (param) {
                    var res = "";
                    res += '{img1|}' + `{text|${param.name}}`;
                    return res;
                  },
                },
              }, {
                name: '压力传感器',
                label: {
                  width: this.screenWidth == 'small'? 50 : 65,
                  height: this.screenWidth == 'small'? 30 : 40,
                  lineHeight: this.screenWidth == 'small'? 30 : 40,
                  // borderWidth: 0.5,  // 边框宽度
                  // borderRadius: 20,  // 边框圆角
                  // borderColor: "#92b188",   // 文字块的边框色
                  backgroundColor: {
                    image: dataList.pressureSensorStatus? itemBgRed : itemBg1
                  },
                  color: '#fff',
                  rich: {
                    // img1: {
                    //   backgroundColor: {
                    //     image: ylcgq,
                    //   },
                    //   height: 16,
                    //   align: 'center'
                    // },
                    text: {
                      fontSize: this.screenWidth == 'small'? 8 : 10,
                      padding: [2, 0, 0, 5],
                      align: 'center'
                    }
                  },
                  formatter: function (param) {
                    var res = "";
                    res += '{img1|}' + `{text|${param.name}}`;
                    return res;
                  },
                },
              }, {
                name: '周波变送器',
                label: {
                  width: this.screenWidth == 'small'? 50 : 65,
                  height: this.screenWidth == 'small'? 30 : 40,
                  lineHeight: this.screenWidth == 'small'? 30 : 40,
                  // borderWidth: 0.5,  // 边框宽度
                  // borderRadius: 20,  // 边框圆角
                  // borderColor: "#92b188",   // 文字块的边框色
                  backgroundColor: {
                    image: dataList.frequencySensorStatus? itemBgRed : itemBg1
                  },
                  color: '#fff',
                  rich: {
                    // img1: {
                    //   backgroundColor: {
                    //     image: zbbsq,
                    //   },
                    //   height: 16,
                    //   align: 'center'
                    // },
                    text: {
                      fontSize: this.screenWidth == 'small'? 8 : 10,
                      padding: [2, 0, 0, 5],
                      align: 'center'
                    }
                  },
                  formatter: function (param) {
                    var res = "";
                    res += '{img1|}' + `{text|${param.name}}`;
                    return res;
                  },
                },
              }]
            }]
          }
        ]
      }]

      this.chart.setOption({
        // tooltip: {
        //   trigger: 'item',
        //   triggerOn: 'mousemove'
        // },
        series: [
          {
            type: 'tree',
            id: 0,
            name: 'tree1',
            data: data,
            orient: 'vertical',
            right: '2%',
            left: '2%',


            initialTreeDepth: 4,
            //   symbol: spirit,  // 1
            //   symbolSize: 20,

            edgeShape: 'polyline', // 折线
            edgeForkPosition: '63%', // 正交布局下当边的形状是折线时，子树中折线段分叉的位置。这里的位置指的是分叉点与子树父节点的距离占整个子树高度的百分比。默认取值是 '50%'，可以是 ['0', '100%'] 之间。
            // 注意：该配置项只有在 edgeShape = 'polyline' 时才有效。
            //   initialTreeDepth: 3,  // 树图初始展开的层级（深度）

            lineStyle: {
              width: 2, // 线的宽度
              color: '#053a69'
            },
            leaves: { // 叶子节点的特殊配置，如上面的树图实例中，叶子节点和非叶子节点的标签位置不同。

            },
            symbolSize: 0,

            expandAndCollapse: true, // 子树折叠和展开的交互，默认打开
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      })
    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  height: 100%;
}
</style>
